import { useEffect } from "react";

import { useQuery } from "@tanstack/react-query";
import axios from "axios";

import { workspacesApi } from "src/api/endpoints";
import { logger } from "src/utils/logger";

const connectionKeys = {
  remoteIcon: (mediaKey: string | null, wsId: string) =>
    ["connections", "remoteIcon", mediaKey, wsId] as const,
};

// Import your API methods if they're not globally available

const fetchRemoteIcon = async (mediaKey: string | null, wsId: string) => {
  if (!mediaKey) return null;
  const res =
    await workspacesApi.getMediaUrlApiV1WorkspacesWorkspaceIdMediaFilePathGet(
      mediaKey.replace("media/", ""),
      wsId,
    );

  const { data: blob } = await axios.get(res.data.url, {
    responseType: "blob",
  });
  return URL.createObjectURL(blob);
};

export const useRemoteIcon = (
  mediaKey: string | null,
  wsId: string,
  { enabled = true }: { enabled?: boolean } = {},
) => {
  const remoteIconQuery = useQuery({
    queryKey: connectionKeys.remoteIcon(mediaKey, wsId),
    queryFn: () => fetchRemoteIcon(mediaKey, wsId),
    enabled,
  });

  useEffect(() => {
    if (remoteIconQuery.isError) {
      logger.warn(
        "There was an error fetching the icon image",
        JSON.stringify(remoteIconQuery.error),
      );
    }
  }, [remoteIconQuery.isError, remoteIconQuery.error]);

  return remoteIconQuery;
};
